"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const ListTree = (props) => React.createElement("svg", { className: "lucide lucide-list-tree", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M21 12h-8M21 6H8M21 18h-8M3 6v4c0 1.1.9 2 2 2h3" }),
    React.createElement("path", { d: "M3 10v6c0 1.1.9 2 2 2h3" }));
exports.default = ListTree;
